module.exports = __webpack_public_path__ + "static/img/jordonsegura_circle150.9b5f608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/jordonsegura_circle150.png
// module id = yJK1
// module chunks = 0